export { default as multiHeaderData } from './multiHeader.json';
export { default as animatedHeaderData } from './animatedHeader.json';
export { default as multiImageData } from './multiImage.json';
export { default as multiImageHeaderData } from './multiImageHeader.json';
export { default as noData } from './noData.json';
export { default as fallbackData } from './fallbackData.json';
